import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { UserLoggedInAndOutEventSchema } from '../../schemas/account/UserLoggedInAndOutEventSchema'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'

export interface UserLoggedInAndOutEventParams extends CommonEventParams {
  LOGIN_OR_SIGNUP_SOURCE: string
}

export class UserLoggedInAndOutClick extends AnalyticsEvent {
  constructor(isLogin: boolean, params: UserLoggedInAndOutEventParams) {
    super(UserLoggedInAndOutEventSchema(isLogin), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackUserLoggedInAndOutClick(
  isLogin: boolean,
  LoggedInAndOutClickParams: UserLoggedInAndOutEventParams
): Promise<void> {
  const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_ONE) || {}
  const { isEnabled = false } = config
  if (isEnabled) {
    const params: UserLoggedInAndOutEventParams = {
      ...getCommonParams(),
      ...LoggedInAndOutClickParams,
    }
    new UserLoggedInAndOutClick(isLogin, params).track()
  }
}
